;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { getCampaignTrackParams } from '../campaign-attribution';
import { captureSafePostHogEvent } from './client';
import type {
  AnalyticsApp,
  AnalyticsFeature,
  AnalyticsReasonCode,
  AuthAction,
  CortextualBannerClickAction,
  EorAction,
  EorActionSource,
  EorFlow,
  EorResult,
  EorMonthlyInputExitReason,
  EorMonthlyInputMode,
  EorMonthlyInputTarget,
  SafePageName,
  ThemePreferenceSource,
  ThemePreferenceValue,
  WalletAction,
  WalletActionSurface,
  WalletFlow,
  WalletFor,
  WalletReimbursementMethod,
  WalletTopupMethod,
} from './types';

interface AuthActionOptions {
  result?: 'success' | 'failure' | 'required';
  reason_code?: AnalyticsReasonCode;
  new_app_access?: boolean;
}

interface SignupCompletedOptions {
  wallet_created: boolean;
}

interface WalletActionOptions {
  flow?: WalletFlow;
  result?: 'started' | 'submitted' | 'initiated' | 'success' | 'failure';
  count?: number;
  amount?: number;
  estimated_amount?: number;
  currency?: string;
  to_currency?: string;
  method?: WalletTopupMethod;
  wallet_for?: WalletFor;
  auto_withdraw?: boolean;
  reimbursement_method?: WalletReimbursementMethod;
  surface?: WalletActionSurface;
  reason_code?: AnalyticsReasonCode;
  invoice_id?: number;
  projection_months?: number;
  keep_percentage?: number;
  extension_days?: number;
}

interface EorActionOptions {
  flow?: EorFlow;
  result?: EorResult;
  count?: number;
  input_type?: string;
  step?: number;
  mode?: EorMonthlyInputMode;
  source?: EorActionSource;
  input_for?: EorMonthlyInputTarget;
  absence_type?: string;
  reason_code?: AnalyticsReasonCode;
  exit_reason?: EorMonthlyInputExitReason;
  from_step?: number;
  to_step?: number;
  error_fields?: string;
  steps_completed?: number;
}

export function trackAuthAction(action: AuthAction, options: AuthActionOptions = {}): void {
  captureSafePostHogEvent('auth_action', {
    app: 'auth-app',
    action,
    ...options,
  });
}

export function trackSignupCompleted(options: SignupCompletedOptions): void {
  captureSafePostHogEvent('signup_completed', {
    app: 'eor-app',
    action: 'completed',
    wallet_created: options.wallet_created,
  });
}

export function trackWalletAction(action: WalletAction, options: WalletActionOptions = {}): void {
  captureSafePostHogEvent('wallet_action', {
    app: 'wallet-app',
    action,
    ...options,
  });
}

export function trackEorAction(action: EorAction, options: EorActionOptions = {}): void {
  captureSafePostHogEvent('eor_action', {
    app: 'eor-app',
    action,
    ...options,
  });
}

export function trackCortextualBannerClick(action: CortextualBannerClickAction): void {
  captureSafePostHogEvent('cortextual_banner_click', {
    app: 'eor-app',
    action,
    ...getCampaignTrackParams(),
  });
}

export function trackSafePageView(app: AnalyticsApp, page: SafePageName): void {
  captureSafePostHogEvent('safe_page_view', {
    app,
    action: page,
  });
}

// One consistent signal for unique-users-per-feature and retention insights.
export function trackFeatureUsed(app: AnalyticsApp, feature: AnalyticsFeature): void {
  captureSafePostHogEvent('feature_used', {
    app,
    feature,
  });
}

interface ThemePreferenceOptions {
  app: AnalyticsApp;
  theme: ThemePreferenceValue;
  source: ThemePreferenceSource;
}

export function trackThemePreference(options: ThemePreferenceOptions): void {
  captureSafePostHogEvent('theme_preference', options);
}

export function toAnalyticsReasonCode(error: Error): AnalyticsReasonCode {
  if ('statusCode' in error && error.statusCode === 403) return 'no_permission';
  return 'request_failed';
}
